(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics', [
        'tf.retailer.Api',
        'tf.retailer.Util',
        'tf.retailer.Charts'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('analytics', {
          parent : 'pageWithMenu',
          url : '/analytics?tla',
          data : {
            auth : {
              privilege : 'retailerViewAnalytics'
            },
            requireTerms:true,
            title:'True Fit Analytics',
            path:'analytics'
          },
          controller : 'AnalyticsCtrl as vm',
          templateUrl : 'Analytics/Analytics.tmpl.html',
          resolve : {
            experiments : function ($stateParams, ExperimentApi) {
              return ExperimentApi.find($stateParams.tla);
            },
            stores : function (Auth, Retailer) {
              if (Auth.can('retailerChangeTla')) {
                return Retailer.find();
              }
            }
          }
        })
        .state('results', {
          parent : 'pageWithMenu',
          url : '/analytics/results/:tla?experiment',
          data : {
            auth : {
              privilege : 'retailerViewAnalytics',
            },
            title:'True Fit Analytics A/B Test Design',
            path:'analytics/results'
          },
          resolve : {
            experiment : function ($stateParams, ExperimentApi) {
              if ($stateParams.experiment) {
                return ExperimentApi.get($stateParams.tla, $stateParams.experiment);
              } else {
                return null;
              }
            },
            intervals : function (AnalyticsApi) {
              return AnalyticsApi.getIntervals();
            }
          },
          controller : function ($scope, $stateParams, experiment, intervals) {
            $scope.experiment = experiment;
            $scope.intervals = intervals;
            $scope.tla = $stateParams.tla;
          },
          template : '<tfc-analytics-view tla="{{ tla }}" experiment="experiment" intervals="intervals"></tfc-analytics-view>'
        })
    ;
  }

})();